const translations = {
    acknowledge: 'Acknowledge',
    activeWarnings: 'Active warnings',
    addNote: 'Add note',
    addToCart: 'Add to cart',
    airworthyDefinitionGrounded: 'Grounded — hard stop, not cleared to fly.',
    airworthyDefinitionHold: 'Hold — soft stop, flight paused pending review.',
    airworthyDefinitionReady: 'Airworthy — cleared to fly.',
    airworthySetBy: 'Set to {{status}} by {{who}} · {{when}}',
    batteryCurrent: 'Current',
    batteryCycles: 'Battery cycles',
    batteryStatusAging: 'Aging',
    batteryStatusDefinitionHold: 'Hold — temporarily out of rotation, under review.',
    batteryStatusDefinitionInService: 'In service — active in rotation.',
    batteryStatusDefinitionRetired: 'Retired — permanently removed from service.',
    batteryStatusHold: 'Hold',
    batteryStatusInService: 'In service',
    batteryStatusOk: 'OK',
    batteryStatusRetired: 'Retired',
    batteryTemperature: 'Temperature',
    batteryVoltage: 'Voltage',
    calibrationFlow: 'Last flow calibration',
    calibrationKindFlow: 'Flow',
    calibrationKindLevel: 'Level',
    calibrationKindMagnetometer: 'Magnetometer',
    calibrationKindPump: 'Pump',
    calibrationKindWeight: 'Weight',
    calibrationLevel: 'Last level calibration',
    calibrationMagnetometer: 'Last magnetometer calibration',
    calibrationPump: 'Last pump calibration',
    calibrationWeight: 'Last weight calibration',
    cartTitle: 'Cart',
    cellVoltages: 'Cell voltages',
    chargeCycles: 'charge cycles',
    comingSoon: 'Preview · coming soon',
    componentStatusDrift: 'Drift',
    componentStatusDue: 'Due',
    componentStatusOk: 'OK',
    componentStatusOvertemp: 'Overtemp',
    componentsTab: 'Components',
    cycleLifeLabel: 'Cycle life',
    cyclesLabel: 'Cycles',
    cyclesUnit: 'cycles',
    dronePrefix: 'S/N',
    droneSearchPlaceholder: 'Search drones by name or serial…',
    droneSerial: 'Drone S/N',
    droneStatus: 'Status',
    editServiceCancel: 'Cancel',
    editServiceSave: 'Save',
    editServiceTitle: 'Edit service record',
    electricalsTab: 'Electricals',
    emDash: '—',
    emptyCart: 'Cart is empty.',
    eventTypeCalibrated: 'Calibrated',
    eventTypeInspected: 'Inspected',
    eventTypeReplaced: 'Replaced',
    eventTypeServiced: 'Serviced',
    faaPrefix: 'FAA',
    faaRegistration: 'FAA reg #',
    faultHistory: 'Fault history · 30 days',
    faults30d: 'Faults · 30d',
    filterAll: 'All',
    filterCaution: 'Caution',
    filterCritical: 'Critical',
    filterDueSoon: 'Due soon',
    filterGrounded: 'Grounded',
    firmwareCompliance: 'Firmware compliance',
    firmwareCompliant: 'Compliant',
    firmwareHistory: 'Firmware history',
    firmwareOutdated: 'Outdated',
    firmwareTab: 'Firmware',
    firmwareVersion: 'Firmware',
    fleetHappy: 'No active warnings. Fleet is happy.',
    fleetHealth: 'Fleet health',
    flightHours: 'flight hours',
    healthTab: 'Health',
    ids: 'IDs',
    intervalConfigCancel: 'Cancel',
    intervalConfigHelper:
        'Set the replacement interval for each part. Wear is tracked as accumulated usage ÷ interval, and parts that reach their interval are flagged for service. Batteries wear by charge cycles; all other parts by flight hours.',
    intervalConfigSave: 'Save',
    intervalConfigTitle: 'Service interval configuration',
    intervalInvalid: 'Enter a value of 1 or more',
    intervalOemDefault: 'OEM {{value}}',
    intervalResetToDefault: 'Reset to default',
    lastInstalled: 'Last installed',
    lastServiceLine: '{{summary}} · {{attribution}}',
    lastSync: 'Last sync',
    lifecycleDefinitionClaimed: 'Claimed — checked out to this fleet and in active use.',
    lifecycleDefinitionReleased: 'Released — returned to the pool, available to claim.',
    lifecycleSetBy: 'Set to {{status}} by {{who}} · {{when}}',
    logService: 'Log service',
    logServiceCalibrationKind: 'Calibration type',
    logServiceCancel: 'Cancel',
    logServiceDate: 'Service date',
    logServiceEventType: 'Event type',
    logServiceNotes: 'Notes',
    logServiceNotesCounter: '{{count}}/{{max}}',
    logServiceNotesPlaceholder: 'Add notes (optional)',
    logServicePart: 'Part',
    logServicePartCondition: 'Installed part condition',
    logServicePartSerialNumber: 'Part serial number',
    logServicePartSerialNumberPlaceholder: 'Add serial number (optional)',
    logServicePhotoCount: '{{count}}/{{max}}',
    logServicePhotoRemove: 'Remove',
    logServicePhotos: 'Photos',
    logServicePhotosCta: 'Click to add photos',
    logServicePhotosFormats: 'JPEG, PNG, or HEIC',
    logServiceRemainingLife: 'Service life remaining',
    logServiceSave: 'Save',
    logServiceTitle: 'Log service',
    logServiceUnit: 'Unit',
    logServiceUnitNumber: 'Unit {{number}}',
    logSynced: 'Synced',
    modelExedyV9: 'Exedy V9',
    modelExedyV12: 'Exedy V12',
    modelSelectorLabel: 'Aircraft model',
    motorsLabel: 'Motors',
    neverRecorded: 'Never recorded',
    nextServiceDue: 'Next service due',
    noBatteries: 'No batteries in the pool.',
    noDronesMatch: 'No drones match the current filter.',
    noFirmwareHistory: 'No firmware updates recorded',
    noPartsDrone: 'No parts recommended. This drone is flying happy.',
    noPartsFleet: 'No parts recommended. Fleet is happy.',
    notApplicableNotReported: 'N/A — not reported',
    notConfigured: 'Not configured',
    openCart: 'View cart →',
    orderPlaced: 'Order placed',
    overviewTab: 'Overview',
    pageTitle: 'Maintenance',
    partBattery: 'Battery',
    partConditionNew: 'New part',
    partConditionUsed: 'Used part',
    partEsc: 'ESC',
    partFlowMeter: 'Flow meter',
    partMotor: 'Motor',
    partNozzleSet: 'Nozzle set',
    partPropSet: 'Propeller set',
    partPumpSealKit: 'Pump seal kit',
    partRtkAntenna: 'RTK antenna',
    partsTab: 'Parts',
    placeOrder: 'Place order',
    productBattery: 'Battery pack 16000mAh',
    productEsc: 'ESC module',
    productFlowMeter: 'Flow meter',
    productMotor: 'Motor (Hobbywing X6)',
    productNozzleSet: 'Nozzle set (4-pack)',
    productPropSet: 'Propeller set (6-pack)',
    productPumpSealKit: 'Pump seal kit',
    productRtkAntenna: 'RTK antenna',
    propsLabel: 'Props',
    pumpRowLabel: 'Pump',
    pumpsLabel: 'Pumps',
    radarBack: 'Back',
    radarDownwardTerrain: 'Downward (terrain)',
    radarFront: 'Front',
    readinessGrounded: 'Grounded',
    readinessHold: 'Hold',
    readinessReady: 'Airworthy',
    recommendedParts: 'Recommended parts',
    remainingLifeInvalid: 'Enter a value between 0 and {{max}}',
    remove: 'Remove',
    returnToServiceHelper: 'Either choice saves this service record.',
    returnToServiceKeepGrounded: 'Keep grounded',
    returnToServiceKeepHold: 'Keep on hold',
    returnToServiceQuestionGrounded: '{{name}} is grounded — return it to service?',
    returnToServiceQuestionHold: '{{name}} is on hold — return it to service?',
    returnToServiceReturn: 'Return to service',
    sectionBatteryPacks: 'Battery packs',
    sectionFirmware: 'Firmware',
    sectionFlowMeter: 'Flow meter',
    sectionMotors: 'Motors',
    sectionPumps: 'Pumps',
    sectionRadars: 'Radars',
    sectionRtk: 'RTK',
    serviceEvent100hMotor: '100h motor inspection',
    serviceEventBatteryTest: 'Battery pack A cycle test',
    serviceEventEscFirmware: 'ESC firmware update · v2.4.1',
    serviceEventPropRotation: 'Prop rotation (front pair)',
    serviceEventPumpCalibration: 'Pump flow calibration',
    serviceEventPumpSeal: 'Pump seal replacement',
    serviceHistoryEmpty: 'No service recorded yet',
    serviceHistoryHeading: 'History',
    serviceOverdue: 'Overdue',
    serviceRecordBack: '← Back',
    serviceRecordBy: 'by {{who}} · {{when}}',
    serviceRecordChangeArrow: '→',
    serviceRecordChangeLogHeading: 'Change log',
    serviceRecordChangedBy: 'Edited by {{who}} · {{when}}',
    serviceRecordEdit: 'Edit',
    serviceRecordInitialUsage: 'Initial usage (used part)',
    serviceRecordNotes: 'Notes',
    serviceRecordPartSerialNumber: 'Part serial number',
    serviceRecordPerformedDate: 'Service date',
    serviceRecordPhotoAdded: 'Photo added',
    serviceRecordPhotoRemoved: 'Photo removed',
    serviceRecordSerialNumber: 'S/N {{serialNumber}}',
    serviceRecordSummary: '{{event}} · {{target}}',
    serviceRecordUsageAtService: 'Usage at service',
    serviceTab: 'Service log',
    serviceUpcomingHeading: 'Upcoming',
    serviceVoid: 'Void',
    serviceVoidedBy: 'Voided by {{who}} · {{when}}',
    serviceWhen4d: 'In 4 days',
    serviceWhen12d: '12 days ago',
    serviceWhen21d: '21 days ago',
    serviceWhen44d: '44 days ago',
    serviceWhen68d: '68 days ago',
    serviceWhen100h: 'In 38 days',
    sinceServiceSuffix: 'since service',
    stateOfHealth: 'State of health',
    statusCaution: 'Caution',
    statusClaimed: 'Claimed',
    statusCritical: 'Critical',
    statusDisabled: 'Disabled',
    statusEnabled: 'Enabled',
    statusGood: 'Good',
    statusReleased: 'Released',
    statusUpdated: 'Status updated',
    subtotal: 'Subtotal',
    toServiceSuffix: 'to service',
    totalAcres: 'Total acres',
    totalDrones: 'Total drones',
    totalFlightHours: 'Total flight hours',
    unitAcres: 'ac',
    unitAll: 'All units',
    unitDays: 'days',
    unitDaysAgo: 'days ago',
    unitFlights: 'Flights',
    unitFlightsLower: 'flights',
    unitHours: 'Hours',
    unitHoursShort: 'h',
    unitMotor: 'Motor {{number}}',
    unitPropAtMotor: 'Prop · Motor {{number}}',
    unitPump: 'Pump {{number}}',
    urgencyDueSoon: 'Due soon',
    urgencyUrgent: 'Urgent',
    usage: 'Usage',
    usedWith: 'Used with',
    viewBatteries: 'Batteries',
    viewDrones: 'Drones',
    viewRecentActivity: 'View recent activity →',
    warningsTab: 'Warnings',
    warranty: 'Warranty',
    warrantyEnd: 'Wty. end',
    warrantyExpPrefix: 'exp',
    warrantyExpired: 'Expired',
    warrantyRemaining: 'Wty. rmng',
    warrantyStart: 'Wty. start',
    watchingLabel: 'Watching'
};

export default translations;
